import { useSettings } from '@capsicum/common';
import { Trade, type TradeAction } from '@capsicum/features/wallet/shared';
import { SellEntrypoint } from '@capsicum/socios-core';
import { useBuySellButtons } from '@capsicum/socios-core-web';
import { useCallback, useEffect, useState } from 'react';

export const useBuySellButtonsForMarketplace = () => {
	const { settings } = useSettings();
	const { isFanTokenDirectPurchaseEnabled, isMarketplaceFanTokenBuyEnabled, isMarketplaceFanTokenSellEnabled } =
		settings;

	const [tradeAction, setTradeAction] = useState<TradeAction>({});
	const { fanTokenCurrencyId, type } = tradeAction;
	const { buy, isLoading, sell } = useBuySellButtons(fanTokenCurrencyId || '');

	const processBuy = type === Trade.Buy;
	const processSell = type === Trade.Sell;

	useEffect(() => {
		if (isLoading) return;

		if (fanTokenCurrencyId) {
			if (processBuy) buy();
			if (processSell) sell(SellEntrypoint.Market);
		}

		setTradeAction({});
	}, [isLoading, type]);

	const handleBuyClick = useCallback((fanTokenCurrencyId?: string) => {
		setTradeAction({ fanTokenCurrencyId, type: Trade.Buy });
	}, []);

	const handleSellClick = useCallback((fanTokenCurrencyId?: string) => {
		setTradeAction({ fanTokenCurrencyId, type: Trade.Sell });
	}, []);

	return {
		handleBuyClick,
		handleSellClick,
		isBuyLoading: processBuy,
		isFanTokenDirectPurchaseEnabled,
		isMarketplaceFanTokenBuyEnabled,
		isMarketplaceFanTokenSellEnabled,
		isSellLoading: processSell,
		tradeTokenId: fanTokenCurrencyId
	};
};
